export default function parsePostLayout(content: string) {
  const modifiedContent = content
    .replace(/<h1>/g, `<h1 class="text-3xl pb-6">`)
    .replace(/<h2>/g, `<h2 class="text-2xl pb-4 pt-2">`)
    .replace(/<h3>/g, `<h3 class="text-xl pb-4 pt-2">`)
    .replace(/<ol>/g, `<ol class="list-decimal pl-4 text-left">`)
    .replace(/<ul>/g, `<ul class="list-disc pl-4 text-left">`)
    .replace(
      /<a(.*?)>/g,
      (_, group) => `<a class="text-blue-600 dark:text-yellow-300 underline" ${group}>`
    );

  return modifiedContent;
}
